var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.5,
    height: 24.5,
    viewBox: "0 0 24.5 24.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_detail",
    transform: "translate(-19.35 -19.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19148",
    "data-name": "Path 19148",
    d: "M31.6,19.6a12,12,0,1,0,12,12,12,12,0,0,0-12-12Zm0,23.171A11.211,11.211,0,1,1,42.811,31.561V31.6A11.21,11.21,0,0,1,31.6,42.811h0Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "ico_view",
    transform: "translate(20.6 20.35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6454",
    "data-name": "Rectangle 6454",
    width: 16,
    height: 16,
    transform: "translate(3 3)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ico_detalle",
    transform: "translate(4 6.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7908",
    "data-name": "Group 7908"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 1.724,
    cy: 1.724,
    r: 1.724,
    transform: "translate(5.276 2.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16570",
    "data-name": "Path 16570",
    d: "M15.94,25.5A10.411,10.411,0,0,0,9.5,22.7a10.411,10.411,0,0,0-6.44,2.8,1.616,1.616,0,0,0,0,2.446,10.411,10.411,0,0,0,6.44,2.8,10.411,10.411,0,0,0,6.44-2.8,1.616,1.616,0,0,0,0-2.446ZM9.5,29.508a2.785,2.785,0,1,1,2.785-2.785A2.792,2.792,0,0,1,9.5,29.508ZM3.561,26.723a.58.58,0,0,1,.192-.427,12,12,0,0,1,2.564-1.724,3.87,3.87,0,0,0,0,4.333,12.53,12.53,0,0,1-2.564-1.754A.531.531,0,0,1,3.561,26.723Zm11.686.427a12,12,0,0,1-2.564,1.724,3.87,3.87,0,0,0,0-4.333A12.531,12.531,0,0,1,15.247,26.3h0a.572.572,0,0,1,0,.855Z",
    transform: "translate(-2.5 -22.7)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDetail);
export default __webpack_public_path__ + "static/media/ico_detail.477168dc.svg";
export { ForwardRef as ReactComponent };